var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "34px",
    viewBox: "0 0 32 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-voqj62zj49-1",
    points: "0 0 32 0 32 34 0 34"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trainingen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trainingen-zoeken",
    transform: "translate(-139.000000, -294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(126.370000, 279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(12.630000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-voqj62zj49-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-voqj62zj49-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93136408,3.03402119 L12.8439318,12.6086336 C13.1055087,12.8892805 13.2503237,13.2586726 13.2503237,13.6424763 L13.2503237,30.6959509 L18.7495031,27.8735527 L18.7495031,13.6424763 C18.7495031,13.2586726 18.8950763,12.890039 19.1558949,12.6086336 L28.0677045,3.03402119 L3.93136408,3.03402119 Z M12.8302843,34 C12.3586878,34 11.8893659,33.8702956 11.4685683,33.6131623 C10.6853542,33.1345455 10.2175486,32.3009481 10.2175486,31.3823982 L10.2175486,14.23942 L0.627155636,3.9366425 C-0.00745254835,3.25398773 -0.177287952,2.26110429 0.194985188,1.40626882 C0.566500134,0.552191857 1.40885341,0 2.34067355,0 L29.6599114,0 C30.5917316,0 31.4340848,0.552191857 31.8055998,1.40702733 C32.1771147,2.2618628 32.0072793,3.25474624 31.3719129,3.9366425 L21.7822782,14.23942 L21.7822782,28.1299275 C21.7822782,29.1152259 21.237895,30.0072281 20.3606648,30.4562632 L14.0251977,33.708734 C13.6461008,33.9029113 13.2374344,34 12.8302843,34 L12.8302843,34 Z",
    id: "Fill-1",
    fill: "currentColor",
    mask: "url(#mask-voqj62zj49-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.72a96d42.svg";
export { ForwardRef as ReactComponent };